import { TextKey } from '@mews-commander/enums';
import { LocalizedTypography } from '@mews-commander/ui';
import { DecimalService, LocalizedCurrencyValue, LocalizedPercentage } from '@mews/framework';
import { usePaymentDetailsSidebarContext } from '../context/PaymentDetailsSidebarContext';
import { DccPaymentDetailsExchangeRateEntry } from './DccPaymentDetailsExchangeRateEntry';
import { PaymentDetailsSidebarGrid } from './PaymentDetailsSidebarGrid';
import { PaymentDetailsSidebarRow } from './PaymentDetailsSidebarRow';

export const DccPaymentSection = () => {
    const { paymentDetails } = usePaymentDetailsSidebarContext();
    const dccPaymentDetail = paymentDetails?.dccPaymentDetail;

    if (!dccPaymentDetail) {
        return null;
    }
    const { chargedAmount, toCurrency, fromCurrency, ecbRateSurchargePercentage } = dccPaymentDetail;
    const hasEcbRate = ecbRateSurchargePercentage && ecbRateSurchargePercentage > 0;

    const referenceRate = LocalizedPercentage({
        value: DecimalService.toNumber(
            DecimalService.divide(
                DecimalService.parse(hasEcbRate ? ecbRateSurchargePercentage : 0),
                DecimalService.parse(100)
            )
        ),
        options: { maximumFractionDigits: 2, showWithoutSymbol: true },
    });

    return (
        <PaymentDetailsSidebarGrid>
            <PaymentDetailsSidebarRow labelTextKey={TextKey.GeneralChargedAmount}>
                <LocalizedCurrencyValue value={{ currency: chargedAmount.currencyCode, value: chargedAmount.value }} />
            </PaymentDetailsSidebarRow>

            <PaymentDetailsSidebarRow labelTextKey={TextKey.ExchangeRate}>
                <DccPaymentDetailsExchangeRateEntry fromCurrency={fromCurrency} toCurrency={toCurrency} />
            </PaymentDetailsSidebarRow>

            {hasEcbRate && (
                <PaymentDetailsSidebarRow labelTextKey={TextKey.ExchangeRateMarkup}>
                    <LocalizedTypography
                        textStyle="bodyMediumStrong"
                        textKey={TextKey.ExchangeRateMarkupReferenceRate}
                        substitutes={{ referenceRate }}
                        as="div"
                    />
                </PaymentDetailsSidebarRow>
            )}
        </PaymentDetailsSidebarGrid>
    );
};
